import Divider from '../../Divider';
import NumField from '../../NumField';
import { format, addDays } from 'date-fns/fp';
import { CapsuleTabContentBody, CapsuleTabContentHeader, ContentRow } from '../CapsuleComponents';
import { IFormState } from '../../../semshared/utils/lister';
import React from 'react';
import { set } from 'lodash';
import { LinkButton } from '../../LinkButton';
import { useTranslation } from 'react-i18next';

interface GuestSectionProps {
  formState: IFormState;
  requestFormStateUpdate: (newState: IFormState) => void;
  simpleMode: boolean;
  setSimpleMode: (simpleMode: boolean) => void;
  setDrawerShow: (s: string) => void;
  setPopupShow: (s: string | null) => void;
}

const GuestSection = ({ formState, requestFormStateUpdate, simpleMode, setSimpleMode, setDrawerShow, setPopupShow }: GuestSectionProps) => {
  const { t } = useTranslation();

  const simple = () => {
    return <ContentRow>
      <div
        style={{
          display: 'flex',
          fontFamily: 'Roboto, sans-serif',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            paddingRight: 0,
            alignSelf: 'center',
          }}
        >
          <NumField
            value={formState.days[0].totalGuests}
            onChange={value => {
              requestFormStateUpdate({
                ...formState,
                days: formState.days.map((day, i) => {
                  const regularST = day.serviceTypes.find(st => st.type === 'REGULAR');
                  const shouldSyncRegular = regularST && day.regularGuestsSynced !== false;

                  return {
                    ...day,
                    serviceTypes: day.serviceTypes.map(st => {
                      if (st.type === 'REGULAR' && shouldSyncRegular) {
                        return { ...st, guestsCount: value };
                      }
                      return st;
                    }),
                    totalGuests: value,
                  };
                })
              });
            }}
          />
        </div>

      </div>
      {simpleMode && <>
        <Divider />
        <div style={{ width: '100%', textAlign: 'left' }}>
          <LinkButton onClick={() => {
            setDrawerShow('participants');
            setPopupShow(null);
          }}>⇾ Details</LinkButton>
        </div>
      </>}
    </ContentRow>
  }

  const advanced = () => {
    return <ContentRow>
      {formState.start &&
        [...Array(formState.days.length)].map((_, index) => (
          <div key={`participants_tab_${index}`}>
            <div
              style={{
                display: 'flex',
                fontFamily: 'Roboto, sans-serif',
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{
                  minWidth: 50,
                  paddingRight: 40,
                  textAlign: 'left',
                }}
              >
                <>
                  <strong>{t('widget:room.day')} {index + 1}</strong>
                  <div>{format('dd.MM.yyyy', addDays(index, formState.start || new Date()))}</div>
                </>
              </div>
              <div
                style={{
                  paddingRight: 0,
                  alignSelf: 'center',
                }}
              >
                <NumField
                  value={formState.days[index].totalGuests}
                  onChange={value => {
                    requestFormStateUpdate({
                      ...formState,
                      days: formState.days.map((day, i) => {
                        if (index === i) {
                          const regularST = day.serviceTypes.find(st => st.type === 'REGULAR');
                          const shouldSyncRegular = regularST && day.regularGuestsSynced !== false;

                          return {
                            ...day,
                            serviceTypes: day.serviceTypes.map(st => {
                              if (st.type === 'REGULAR' && shouldSyncRegular) {
                                return { ...st, guestsCount: value };
                              }
                              return st;
                            }),
                            totalGuests: value,
                          };
                        } else {
                          return day;
                        }
                      }),
                    });
                  }}
                />
              </div>
            </div>
            <Divider />
          </div>
        ))}
    </ContentRow>
  }

  return <>
    {simpleMode && <CapsuleTabContentHeader>{t('widget:headers.pleaseEnterParticipants')}</CapsuleTabContentHeader>}
    <CapsuleTabContentBody>
      {simpleMode ? simple() : advanced()}
    </CapsuleTabContentBody>
  </>
};
export default GuestSection;
